(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woventon-feature-columns"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wv-feature-columns')) {
    customElements.define('wv-feature-columns', class extends HTMLElement {
      connectedCallback() {
        this.bootFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.bootFrame);
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = 0;
        this.events?.abort();
        this.resizeObserver?.disconnect();
      }

      initialize() {
        if (!this.isConnected) return;
        this.list = this.querySelector('[data-wfc-list]');
        this.progress = this.querySelector('[data-wfc-progress]');
        this.thumb = this.querySelector('[data-wfc-thumb]');
        if (!this.list || !this.progress || !this.thumb) return;

        this.cards = [...this.querySelectorAll('[data-wfc-card]')];
        this.desktop = matchMedia('(min-width: 1024px)');
        this.events?.abort();
        this.events = new AbortController();
        const signal = this.events.signal;
        this.list.addEventListener('scroll', this.scheduleUpdate, { passive: true, signal });
        this.list.addEventListener('keydown', this.onKeydown, { signal });
        this.list.addEventListener('load', this.scheduleUpdate, { capture: true, signal });
        this.addEventListener('shopify:block:select', this.onBlockSelect, { signal });
        window.addEventListener('resize', this.scheduleUpdate, { passive: true, signal });

        if ('ResizeObserver' in window) {
          this.resizeObserver?.disconnect();
          this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
          this.resizeObserver.observe(this.list);
          this.cards.forEach(card => this.resizeObserver.observe(card));
        }
        this.classList.add('wv-feature-columns--enhanced');
        this.update();
      }

      scheduleUpdate = () => {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = 0;
          if (this.isConnected) this.update();
        });
      };

      update() {
        const viewport = this.list.clientWidth;
        const content = this.list.scrollWidth;
        this.maximum = Math.max(0, content - viewport);
        this.rtl = getComputedStyle(this.list).direction === 'rtl';
        this.scrollable = !this.desktop.matches && this.cards.length > 1 && this.maximum > 1 && viewport > 0;
        this.progress.hidden = !this.scrollable;
        this.list.tabIndex = this.scrollable ? 0 : -1;

        if (!this.scrollable) {
          this.list.removeAttribute('aria-describedby');
          return;
        }
        const help = this.querySelector('[data-wfc-help]');
        if (help) this.list.setAttribute('aria-describedby', help.id);

        const trackWidth = this.progress.clientWidth;
        const thumbWidth = Math.min(trackWidth, Math.max(24, trackWidth * viewport / content));
        const offset = Math.min(this.maximum, Math.max(0, this.rtl ? -this.list.scrollLeft : this.list.scrollLeft));
        const position = (trackWidth - thumbWidth) * offset / this.maximum;
        this.thumb.style.width = `${thumbWidth}px`;
        this.thumb.style.transform = `translate3d(${this.rtl ? -position : position}px, 0, 0)`;
      }

      onKeydown = event => {
        if (event.target !== this.list || !this.scrollable || event.altKey || event.ctrlKey || event.metaKey) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = this.rtl ? -this.list.scrollLeft : this.list.scrollLeft;
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;
        let target = current;
        if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = this.maximum;
        else {
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          target += step * direction * (this.rtl ? -1 : 1);
        }
        target = Math.max(0, Math.min(this.maximum, target));
        this.list.scrollTo({
          left: this.rtl ? -target : target,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      onBlockSelect = event => {
        if (this.desktop.matches) return;
        const card = this.cards.find(item => item.dataset.wfcCard === event.detail?.blockId);
        if (!card) return;
        const listRect = this.list.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const styles = getComputedStyle(this.list);
        const delta = this.rtl
          ? cardRect.right - listRect.right + parseFloat(styles.paddingRight)
          : cardRect.left - listRect.left - parseFloat(styles.paddingLeft);
        this.list.scrollTo({ left: this.list.scrollLeft + delta, behavior: 'auto' });
        this.scheduleUpdate();
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woventon-made-to-be-felt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wv-made-to-be-felt')) {
    class WoventonMadeToBeFelt extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.setupFrame) return;
        this.setupFrame = requestAnimationFrame(() => {
          this.setupFrame = null;
          this.initialize();
        });
      }

      initialize() {
        this.gallery = this.querySelector('[data-felt-gallery]');
        if (!this.gallery || this.controller) return;
        this.slides = Array.from(this.querySelectorAll('[data-felt-slide]'));
        this.buttons = Array.from(this.querySelectorAll('[data-felt-go]'));
        this.progress = this.querySelector('[data-felt-progress]');
        this.thumb = this.querySelector('[data-felt-progress-thumb]');
        this.status = this.querySelector('[data-felt-status]');
        this.controller = new AbortController();
        this.activeIndex = -1;
        this.rtl = getComputedStyle(this.gallery).direction === 'rtl';
        const signal = this.controller.signal;

        this.gallery.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
        this.gallery.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => {
            this.goTo(Number(button.dataset.feltGo));
            this.gallery.focus({ preventScroll: true });
          }, { signal });
        });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
          this.resizeObserver.observe(this.gallery);
        } else {
          window.addEventListener('resize', () => this.scheduleUpdate(), { passive: true, signal });
        }
        this.classList.add('wv-felt--enhanced');
        this.update();
      }

      scheduleUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = null;
          this.update();
        });
      }

      update() {
        const width = this.gallery.clientWidth;
        const total = this.gallery.scrollWidth;
        const max = Math.max(0, total - width);
        const offset = Math.min(max, Math.max(0, Math.abs(this.gallery.scrollLeft)));
        const ratio = total > 0 ? Math.min(1, width / total) : 1;
        const fraction = max > 0 ? offset / max : 0;

        if (this.progress && this.thumb) {
          this.progress.hidden = max < 2 || this.slides.length < 2;
          this.thumb.style.setProperty('--wv-felt-progress-size', `${ratio * 100}%`);
          this.thumb.style.setProperty('--wv-felt-progress-position', `${fraction * (1 - ratio) * 100}%`);
        }

        const viewport = this.gallery.getBoundingClientRect();
        const center = viewport.left + viewport.width / 2;
        let nearestIndex = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const candidate = Math.abs(rect.left + rect.width / 2 - center);
          if (candidate < distance) {
            distance = candidate;
            nearestIndex = index;
          }
        });

        if (nearestIndex !== this.activeIndex) {
          this.activeIndex = nearestIndex;
          this.buttons.forEach((button) => {
            button.hidden = Number(button.dataset.feltGo) === nearestIndex;
          });
          if (this.status) this.status.textContent = `Image ${nearestIndex + 1} of ${this.slides.length}`;
        }
      }

      goTo(index) {
        const target = this.slides[Math.max(0, Math.min(this.slides.length - 1, index))];
        if (!target) return;
        const first = this.slides[0].getBoundingClientRect();
        const next = target.getBoundingClientRect();
        const distance = Math.abs(next.left - first.left);
        const max = Math.max(0, this.gallery.scrollWidth - this.gallery.clientWidth);
        const left = Math.min(max, distance) * (this.rtl ? -1 : 1);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.gallery.scrollTo({ left, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      onKeydown(event) {
        if (event.target !== this.gallery || this.slides.length < 2) return;
        let next = this.activeIndex;
        if (event.key === 'ArrowRight') next += this.rtl ? -1 : 1;
        else if (event.key === 'ArrowLeft') next += this.rtl ? 1 : -1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.slides.length - 1;
        else return;
        event.preventDefault();
        this.goTo(next);
      }

      disconnectedCallback() {
        if (this.setupFrame) cancelAnimationFrame(this.setupFrame);
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        this.setupFrame = null;
        this.updateFrame = null;
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.classList.remove('wv-felt--enhanced');
      }
    }

    customElements.define('wv-made-to-be-felt', WoventonMadeToBeFelt);
  }

  } catch(e) { console.error(e); }
})();
})();
